export enum AbsenceOptionUnit {
  DAYS = 'days',
  HOURS = 'hours',
}

export enum CursorType {
  NO_DROP = 'no-drop',
  POINTER = 'pointer',
  GRABBING = 'grabbing',
}

export enum DecimalPrecision {
  DEFAULT = 2,
  PERCENTAGE = 2,
  VACATION_CALCULATION = 5,
  MONEY = 2,
}

export enum AccountType {
  SHIFTBASE = 'ShiftBase',
}

export enum CanCreateOptions {
  NOT_ALLOWED_PERMISSION = 'not-allowed-permission',
  ALLOWED = 'allowed',
  NOT_ALLOWED_INACTIVE = 'not-allowed-inactive',
}

export enum EnvironmentType {
  DEVELOPMENT = 'dev',
  STAGING = 'staging',
  REVIEW = 'review',
  PRODUCTION = 'production',
}

export enum AbsenceCalculationType {
  CONTRACT = 'contract',
  SCHEDULED = 'scheduled',
  NONE = 'none',
}

export enum PeriodType {
  TEAM,
  EMPLOYEE,
}

export enum ViewType {
  EMPLOYEE = 'employee',
  TEAM = 'team',
}

export enum ColumnFiltersType {
  NONE,
  PERIOD_OVERVIEW = 'period-overview-columns',
  SCHEDULE_OVERVIEW = 'schedule-overview-columns',
  SCHEDULE_DETAIL = 'schedule-detail-columns',
  OPEN_SHIFTS = 'open-shifts-columns',
  EMPLOYEES_PLUS_MINUS = 'employees-plus-minus-columns',
  EMPLOYEES_AVAILABILITY = 'employees-availability-columns',
  EMPLOYEES = 'employees-columns',
  EMPLOYEES_ABSENT = 'employees-absent-columns',
  TURNOVER = 'turnover-columns',
  PAYROLL = 'payroll-columns',
  TIMESHEET_OVERVIEW = 'timesheet-overview-columns',
  TIMESHEET_DIARY = 'timesheet-diary-columns',
  TIMESHEET_CLOSED = 'timesheet-closed-columns',
  TIMESHEET_DETAIL = 'timesheet-detail-columns',
  SCHEDULE_TIMESHEET = 'schedule-timesheet-columns',
}

export enum ReportExportType {
  HTML = 'html',
  EXCEL = 'xlsx',
  CSV = 'csv',
}

export enum ChangeDetectionType {
  DETECT_CHANGES,
  MARK_FOR_CHECK,
}

export enum DragType {
  OPEN_SHIFT,
  REQUIRED_SHIFT,
  SCHEDULE,
  SHIFT,
  EVENT,
}

export enum DropZoneType {
  OPEN_SHIFT,
  REQUIRED_SHIFT,
  SCHEDULE,
  SHIFT,
  EVENT,
}

export enum Features {
  // Permanent featureflag, in case Widgetbrain has trouble on their side again.
  WIDGETBRAIN = 'widgetbrain',
  SHOW_CHARGEBEE_TEST_BUTTONS = 'show_chargebee_test_buttons',
  SENTRY_LOGGING = 'sentry_logging',
  PHRASE_IN_CONTEXT_EDITOR = 'phrase-in-context-editor',
  IMPORT_PUBLIC_HOLIDAYS = 'import_public_holidays',

  // Temporary featureflags, to be removed when the feature is fully rolled out.
  TMP_CHARGEBEE_MIGRATION_RUNNING = 'tmp_chargebee_migration_running',
  TMP_SHIFT_TEMPLATE_EMPLOYABILITY_ENDPOINT = 'tmp_shift_template_employability_endpoint',
  TMP_AVAILABILITY_OPTIMISATION = 'tmp_availability_optimisation',
  TMP_PERSONIO_INTEGRATION_ABSENCE = 'tmp_personio_integration_absence',
  TMP_STARTER_TO_BASIC = 'tmp_starter_to_basic',
  TMP_REFINER = 'tmp_refiner',
  TMP_TIMESHEET_STATEMENTS = 'tmp_timesheet_statements',
  TMP_TIMESHEET_STATEMENTS_INTRO_BANNER = 'tmp_timesheet_statements_intro_banner',
  TMP_PUBLIC_HOLIDAY_GROUP_PROMOTION_INTRO_BANNER = 'tmp_public_holiday_group_promotion_intro_banner',
  TMP_REQUEST_GUESTPLAN_INTEGRATION = 'tmp_request_guestplan_integration',
  TMP_AFAS_LEAVE_OF_ABSENCE = 'tmp_afas_leave_of_absence',
  TMP_APPROVE_TIMESHEETS_SHOW_EXTERNAL_EMPLOYEES = 'tmp_approve_timesheets_show_external_employees',
  TMP_AFAS_REST_PAYROLL = 'tmp_afas_rest_payroll',
  TMP_PERSONIO_ORGANISATION_WIDE_MAPPING = 'tmp_personio_organisation_wide_mapping',
  TMP_AFAF_SEND_WELCOME_EMAIL_ON_EMPLOYEE_IMPORT = 'tmp_afas_send_welcome_email_on_employee_import',
  TMP_REPLACE_WAGE_WITH_CTC = 'tmp_replace_wage_with_ctc',
  TMP_AUTOMATED_ABSENCE_CREATION_PUBLIC_HOLIDAYS = 'tmp_automated_absence_creation_public_holidays',
  TMP_BALANCE_EXPIRATION = 'tmp_balance_expiration',
  TMP_BALANCE_REACTIVATE_CORRECTION = 'tmp_balance_reactivate_correction',
  TMP_BETA_PROGRAM = 'tmp_beta_program',
  TMP_PERSONIO_OCCUPATION_TYPES = 'tmp_personio_occupation_types',
  TMP_INTEGRATION_SPLIT_CONTRACT_TYPE_SAVING = 'tmp_integration_split_contract_type_saving',
  TMP_PERSONIO_DEFAULT_EMPLOYEE_MAPPING = 'tmp_personio_default_employee_mapping',
  TMP_IMPROVED_MAPPING_VALIDATION = 'tmp_improved_mapping_validation',
  TMP_HOORAY_TIME_OFF_BALANCE_EXPORT = 'tmp_hooray_time_off_balance_export',
  TMP_HOORAY_SICKNESS_ABSENCE_EXPORT = 'tmp_hooray_sickness_absence_export',
  TMP_SELF_ONBOARDING_PAYROLL_CHAPTER = 'tmp_self_onboarding_payroll_chapter',
  TMP_SDWORX_TEXT_INPUTS = 'tmp_sdworx_text_inputs',
  TMP_INSIGHTS_PAGE_INTRO_BANNER = 'tmp_insights_page_intro_banner',
  TMP_INSIGHTS_REPORTS = 'tmp_insights_reports',
  TMP_TIME_TRACKING_ENDPOINT = 'tmp_time_tracking_endpoint',
  TMP_ONBOARDING_VARIATION_V10 = 'tmp_onboarding_variation_v10',
  TMP_AUTO_SELECT_BALANCE = 'tmp_auto_select_balance', // cleanup: #SHB-13467
  TMP_CONTRACT_TEMPLATE = 'tmp_contract_template',
  TMP_CONTRACT_TEMPLATE_FEEDBACK = 'tmp_contract_template_feedback',
  TMP_EMPLOYEE_SENTIMENT = 'tmp_employee_sentiment',
  TMP_HOTJAR = 'tmp_hotjar',
  TMP_SPICED_SIGN_UP = 'tmp_spiced_sign_up',
  TMP_MONTHLY_TARGETS = 'tmp_monthly_targets',
}

export enum DateFormatType {
  DEFAULT = 'yyyy-MM-dd',
  DAY_FULL = 'eeeeee P',
  DATE_WITH_TIME = 'yyyy-MM-dd HH:mm:ss',
  TIME = 'HH:mm',
  LONG_LOCALIZED = 'P',
}

export enum DropZoneType {
  COPY = 'copy-dropzone',
  MOVE = 'move-dropzone',
  NONE = 'none-dropzone',
}

export const IntlFormatType = {
  DATETIME_WITH_SECONDS: { dateStyle: 'short', timeStyle: 'medium' },
  DATETIME: { dateStyle: 'short', timeStyle: 'short' },
  DATE: { dateStyle: 'short' },
  MEDIUM_DATETIME: { dateStyle: 'medium', timeStyle: 'medium' },
};

export enum SelfOnboardingSegment {
  SMB_NL_HOSPITALITY = 'smb_nl_hospitality',
}

// API is using this prop names for weekdays
export enum DayKeys {
  MONDAY = 'mo',
  TUESDAY = 'tu',
  WEDNESDAY = 'we',
  THURSDAY = 'th',
  FRIDAY = 'fr',
  SATURDAY = 'sa',
  SUNDAY = 'su',
}
